import { C as Cart } from './cart-Br6PnlY6.js';
import { P as Pubsub } from './pubsub-DKqIEqaC.js';
import './notyf-DIw0RvBj.js';

class CartDrawer extends HTMLElement {
  connectedCallback() {
    Pubsub.subscribe('cart:add', async () => {
      const cartData = await Cart.get();
      Shopify.analytics.publish('karl:cart_drawer_viewed', { cart: cartData });
    });
  }
}

customElements.define('cart-drawer', CartDrawer);
